import { RouteRecordRaw } from 'vue-router';
import { NotificationPage } from '@/pages/notification';
import MyNotifications from '@/pages/notification/ui/MyNotifications.vue';
import GeneralNotifications from '@/pages/notification/ui/GeneralNotifications.vue';

export const routeName = 'Notificacao';

export const route: RouteRecordRaw = {
  path: 'notificacao',
  name: routeName,
  component: NotificationPage,
  redirect: 'notificacao/minhas-notificacoes',
  meta: {
    requiresAuth: true,
    breadcrumb: 'Notificações',
  },
  children: [
    {
      path: 'minhas-notificacoes',
      name: 'MinhasNotificacoes',
      component: MyNotifications,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Minhas Notificações',
      },
    },
    {
      path: 'notificacoes-gerais',
      name: 'NotificacoesGerais',
      component: GeneralNotifications,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Notificações Gerais',
        permissions: [{ action: 'readGeneral', subject: 'Notification' }],
      },
    },
  ],
};
